import React, { useCallback, useContext, useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FootballContext } from '../../Home/FootballPage';
import { SingleMatchTable } from '../Common/MatchTable';
import CashOutTable from '../Common/CashOutTable';
import { MatchDropdown, Remark, MatchInfo, getFoPool } from '../Common/MatchBase';
import { isLogonHigh } from '../../BetSlip/LoginHooks';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { hasMatchInfoUpdate, MatchUpdateMsg } from '../Common/Common';
import { useWindowSize } from '../../Common/CommonHooks';
import getDistanceOfPageTop from '../../Common/utils/getDistanceOfPageTop';
import { FBMatchTypeTab } from '../../Common/ui-components/FBMatchTypeTab';
import { scrollTo } from '../../Common/GlobalFunc';

const INPLAY_ALL = () => {
    const { t } = useTranslation();
    const context = useContext(FootballContext);
    const globalContext = useContext(GlobalContext);
    const singleMatch = context.content.matchData.matches?.[0];
    const AllOddsOrder = context.content.config.AllOddsOrder;
    const { isMobileSize } = useWindowSize()
    const MatchBetTypeFilteringTab = context.content.config.MatchBetTypeFilteringTab;
    const [matchTimeType, setMatchTimeType] = useState(MatchBetTypeFilteringTab?.[0]?.key)
    const [gsTab, setGsTab] = useState('GS')
    
        useEffect(()=>{
            if(matchTimeType ==='PLAYER' &&  singleMatch?.foPools){
                let GSBetTypes = window.fbConfig.GSPools
                let GSPools = singleMatch.foPools.filter(pool => GSBetTypes.includes(pool.oddsType))
                if(GSPools.length == 1 ) {
                    setGsTab(GSPools[0].oddsType)
                }
            }
        },[singleMatch?.foPools, matchTimeType, gsTab])

    const onChangeMatchTimeType = (value) =>{
        if(value != matchTimeType){
            setGsTab('GS')
        }
        setMatchTimeType(value)
        // if(value == 'ALL') return
        // const isFT = value == 'FT'
        // const curPools = isFT ? window.fbConfig.FullTimePools : window.fbConfig.FirstHalfPools
        // context.contentRef.current.oddsSelection.forEach(item =>{
        //     if(!curPools.includes(item.oddsType)){
        //         item.checked = false
        //     }
        // })
        // context.setContent({...context.contentRef.current})
    }

    useLayoutEffect(() => {
        if ( window.location.hash!='' ) {
            setTimeout(() => {
                let typeStr = window.location.hash.substring(1).toUpperCase()
                let match = document.querySelectorAll('section.INPLAY_ALL > div');
                let section = document.querySelectorAll('section.INPLAY_ALL > section');
                if(isMobileSize) {
                    let shiftVal = 0
                    if(document.getElementById('date-tourn-selection-sticky'))
                        shiftVal -= document.getElementById('date-tourn-selection-sticky').offsetHeight
                    console.debug(shiftVal)
                    if(document.getElementsByClassName('matchDropdownContainer-MatchInfoContent')?.length>0)
                         shiftVal -= document.getElementsByClassName('matchDropdownContainer-MatchInfoContent')[0].offsetHeight
                    if([...match].find((el => el.classList.contains("coupon" + typeStr)))){
                        window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains("coupon" + typeStr))))+(shiftVal))
                    }
                    else if([...match].find((el => el.classList.contains(typeStr)))){
                        window.scrollTo(0, getDistanceOfPageTop([...match].find((el => el.classList.contains(typeStr))))+(shiftVal))
                    }
                    else if([...section].find((el => el.classList.contains("coupon" + typeStr)))){
                        window.scrollTo(0, getDistanceOfPageTop([...section].find((el => el.classList.contains("coupon" + typeStr))))+(shiftVal))
                    }
                    else if([...section].find((el => el.classList.contains(typeStr)))){
                        window.scrollTo(0, getDistanceOfPageTop([...section].find((el => el.classList.contains(typeStr))))+(shiftVal))
                    }
                } else {
                    if([...match].find((el => el.classList.contains("coupon" + typeStr)))){
                        [...match].find((el => el.classList.contains("coupon" + typeStr))).scrollIntoView()
                    }
                    else if([...match].find((el => el.classList.contains(typeStr)))){
                        [...match].find((el => el.classList.contains(typeStr))).scrollIntoView()
                    }
                    else if([...section].find((el => el.classList.contains("coupon" + typeStr)))){
                        [...section].find((el => el.classList.contains("coupon" + typeStr))).scrollIntoView()
                    }
                    else if([...section].find((el => el.classList.contains(typeStr)))){
                        [...section].find((el => el.classList.contains(typeStr))).scrollIntoView()
                    }
                }
            }, 1000);
        } else {
            // scrollTo(0, 0)
        }
    }, [window.location.hash])

    const MatchInfoContent = useCallback(({ singleMatch, context }) => {
        return <MatchInfo context={context} singleMatch={singleMatch} />
    }, [])

    const AllMatchTable = useCallback(({ singleMatch, matchTimeType, context, t, gsTab,setGsTab }) => {
        if(hasMatchInfoUpdate(context.content)){
            return <MatchUpdateMsg/>
        }
        let curAllOddsOrder = AllOddsOrder;
        if(matchTimeType != 'ALL'){
            const pools = MatchBetTypeFilteringTab.find(i=> i.key == matchTimeType)?.filterType
            curAllOddsOrder = curAllOddsOrder.filter(i => pools.includes(i))
        }
        return curAllOddsOrder.map(betType => {
            let foPool = getFoPool(singleMatch, betType, null);
            if(MatchBetTypeFilteringTab?.find(i=> i.key == matchTimeType)?.excludeType?.includes(betType) ){
                return null
            }
            if(matchTimeType ==='PLAYER'){
                if(betType == 'GS' && foPool.length <= 1) return null
                let GSBetTypes = window.fbConfig.GSPools
                let GSPools = singleMatch.foPools.filter(pool => GSBetTypes.includes(pool.oddsType))
                if(GSPools.length > 1 && GSBetTypes.includes(betType)) return null
            }
            return (foPool==null ||  foPool?.length == 0) ? null :  <SingleMatchTable betType={betType} match={singleMatch} foPool={foPool} key={betType} matchTimeType={matchTimeType} gsTab={gsTab} setGsTab={setGsTab}/>;
        })
    }, [])

    return (
        <>
            <section className='INPLAY_ALL'>
                {singleMatch ? <>
                    {!context.state.windowSize.isMobileSize && <>
                        <div className='match-dropdown-container ddNoRSpace'><MatchDropdown singleMatch={singleMatch} /></div>
                        <MatchInfoContent singleMatch={singleMatch} context={context}/>
                    </>}
                    {/*globalContext.globalState.commonCtrl.earlySettlementEnabled && isLogonHigh() && <CashOutTable match={singleMatch} />*/}
                    {globalContext.globalState.commonCtrl.enableFOBetTypesFilterTab &&<FBMatchTypeTab allMatchTimeTypes={MatchBetTypeFilteringTab} selected={matchTimeType} onChange={onChangeMatchTimeType} match={singleMatch} context={context}/>}
                    <AllMatchTable matchTimeType={matchTimeType}  singleMatch={singleMatch}  context={context} t={t} gsTab={gsTab} setGsTab={setGsTab}/>
                </> : <MatchUpdateMsg />}
            </section>
            <div className='mobileMarginLR'>
                <Remark betType={'INPLAY_ALL'} />
            </div>
        </>
    )
}
export default INPLAY_ALL;